export enum PAYMENT_TERMS_TYPE {
    package = 'PACKAGE',
    booking = 'BOOKING',
    deposit = 'DEPOSIT',
    ADS = 'ADVERISTMENT',
    market_Place = 'MARKT-PLACE',
}